<template>
  <div>
    <v-card class="mb-2" outlined>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="addItem">
          <slot></slot>
          <v-btn type="submit" color="primary">Add {{ itemTitle }}</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card outlined>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          disable-sort
          disable-pagination
        >
          <template v-slot:item.action="{ item }">
            <v-icon small @click="$emit('delete-item', item)">mdi-close</v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'EditTable',
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, required: true },
    itemTitle: {
      type: String,
      required: false,
      default: 'Item'
    }
  },
  data() {
    return {
      valid: true
    }
  },
  methods: {
    addItem() {
      if (this.$refs.form.validate()) {
        this.$emit('add-item')
      }
    }
  }
}
</script>

<style scoped></style>
